<template>
  <div class="order-view">
    <nav-menu :navMenuList="navMenuList"
    :activeIndex="activeIndex1"
    @handleSelect="handleSelect1"></nav-menu>
    <el-menu
    :default-active="activeIndex"
    class="el-menu-demo"
    mode="horizontal"
    text-color="#666666"
    @select="handleSelect"
    active-text-color="#b60e0e">
      <el-menu-item v-for="(item, index) in orderMenu" :key="index" :index="index.toString()">
        {{item.text}}
      </el-menu-item>
    </el-menu>
    <ol class="order-title">
      <li class="li-1">订单详情</li>
      <li>书籍类型</li>
      <li class="li-2">订单状态</li>
      <li class="li-3">操作</li>
    </ol>
    <router-view></router-view>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
      navMenuList: [{
        text: '我的订单',
        pathName: 'MyOrder'
      }],
      activeIndex: '0',
      activeIndex1: '0',
      orderMenu: [{
        text: '全部订单',
        pathName: 'AllOrder'
      }, {
        text: '待付款',
        pathName: 'WaitPay'
      }, {
        text: '待发货',
        pathName: 'WaitFh'
      }, {
        text: '待收货',
        pathName: 'WaitSh'
      }]
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.$router.push({
        name: this.orderMenu[key].pathName
      })
    },
    handleSelect1 (key) {
      this.activeIndex1 = key
      // console.log(this.navMenuList[key].text)
    }
  }
}
</script>
<style lang="less" scoped>
  .el-menu--horizontal{
    margin-top: 40px;
  }
  .el-menu-item{
    line-height: 30px !important;
    height: 30px !important;
  }
  .order-view{
    .order-title{
      list-style: none;
      padding: 0;
      margin: 0;
      background-color: #F5F5F5;
      margin-top: 25px;
      display: flex;
      font-size: 14px;
      line-height: 30px;
      .li-1{
        flex: 1;
        padding: 0 140px;
      }
      .li-2{
        width: 300px;
        text-align: center;
      }
      .li-3{
        width: 80px;
        text-align: center;
        padding: 0 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/MyOrder/myorder.vue


// WEBPACK FOOTER //
// src/components/Personal/MyOrder/myorder.vue